module.exports = __webpack_public_path__ + "img/md-logo.f84b9f40.png";